/**
 * Convert a string from camelCase to snake_case
 * @param str: string
 */
export const convertCamelToSnakeCase = (str: string) => {
  return str.toLowerCase().replace(' ', '_')
}
